function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.5,0,8.306.056a.862.862,0,0,0-.611.25L.25,7.75a.872.872,0,0,0,0,1.222L6.028,14.75a.872.872,0,0,0,1.222,0l7.444-7.444a.862.862,0,0,0,.25-.611L15,2.5Zm.306,3.222a.727.727,0,0,1-1.028-1.028.727.727,0,0,1,1.028,1.028Z",
  transform: "translate(0 15) rotate(-90)"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15"
  }, props), _ref);
};

export default __webpack_public_path__ + "storage/static/media/products.e92375b9.svg";
export { SvgComponent as ReactComponent };